import FORTIUM_EXT_1 from "./FORTIUM_EXT_1";
export default {
  FORTIUM_EXT_1,
};
